import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { I18NextModule } from 'angular-i18next';

@Component({
  standalone: true,
  selector: 'app-modal-incomplete-data',
  templateUrl: './modal-incomplete-data.component.html',
  styleUrls: ['./modal-incomplete-data.component.scss'],
  imports: [CommonModule, I18NextModule, MatDialogModule]
})
export class ModalIncompleteDataComponent {
  @Output() submitRequestEmitter = new EventEmitter<boolean>();

  constructor(
    public dialogRef: MatDialogRef<ModalIncompleteDataComponent>,
    private router: Router
  ) {}

  goManageData() {
    this.dialogRef.close();
    this.router.navigateByUrl('/manage-data');
  }
}
